import styled from 'styled-components';
import { Column } from 'components/shared/Layout';

export const StyledColumn = styled(Column)`
  button {
    width: 100%;
  }
`;
